var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "Kural Test Et",
        width: "700px",
        footer: null,
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "rule-tester" }, [
        _c("div", { staticClass: "tester-header" }, [
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n                Kuralınızın kaç kişi ile eşleşeceğini test edebilirsiniz\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tester-body" }, [
          _c(
            "div",
            { staticClass: "rule-selector" },
            [
              _c("label", [_vm._v("Kural Seçin")]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Test edilecek kuralı seçin" },
                  model: {
                    value: _vm.selectedRuleId,
                    callback: function ($$v) {
                      _vm.selectedRuleId = $$v
                    },
                    expression: "selectedRuleId",
                  },
                },
                _vm._l(_vm.rules, function (rule) {
                  return _c(
                    "a-select-option",
                    { key: rule.id, attrs: { value: rule.id } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(rule.name) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "test-action" },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    loading: _vm.testing,
                    disabled: !_vm.selectedRuleId,
                    block: "",
                  },
                  on: { click: _vm.runTest },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("play_arrow"),
                  ]),
                  _vm._v("\n                    Test Et\n                "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.testResult
            ? _c(
                "div",
                { staticClass: "test-results" },
                [
                  _c(
                    "a-alert",
                    {
                      attrs: {
                        message: "Kural Bilgileri",
                        type: "info",
                        "show-icon": "",
                      },
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "rule-info" }, [
                          _c("div", [
                            _c("strong", [_vm._v("Ne Zaman:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.testResult.info.when === "contact_created"
                                    ? "Müşteri Kartı Oluştuğunda"
                                    : "Chat Açıldığında"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [_vm._v("Koşul Sayısı:")]),
                            _vm._v(
                              " " + _vm._s(_vm.testResult.info.conditionCount)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("strong", [_vm._v("Aksiyon Sayısı:")]),
                            _vm._v(
                              " " + _vm._s(_vm.testResult.info.actionCount)
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }